import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

const BLOCKS = [
    { key: 'news', title: '独家原创' },
    { key: 'finance', title: '财经信源' },
    { key: 'tech', title: '科技精选' },
];

const toList = data => {
    const list = Array.isArray(data) ? data : data && Array.isArray(data.data) ? data.data : [];

    return list
        .filter(item => item && item.title && (item.url || item.wwwUrl || item.link))
        .slice(0, 10)
        .map((item, index) => ({
            id: item.id || item.base62Id || index,
            title: item.title,
            url: item.url || item.wwwUrl || item.link,
        }));
};

class OriginalFeed extends React.PureComponent {
    static propTypes = {
        news: PropTypes.array,
        finance: PropTypes.array,
        tech: PropTypes.array,
    };

    render() {
        const blocks = BLOCKS.map(item => ({
            ...item,
            list: toList(this.props[item.key]),
        })).filter(item => item.list.length > 0);

        if (blocks.length === 0) {
            return null;
        }

        return (
            <div>
                {blocks.map(item => (
                    <section className={styles.block} key={item.key} aria-label={item.title}>
                        <div className={styles.title}>{item.title}</div>
                        <ul className={styles.list}>
                            {item.list.map(article => (
                                <li className={styles.item} key={article.id}>
                                    <a href={article.url} title={article.title}>
                                        {article.title}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </section>
                ))}
            </div>
        );
    }
}

export default errorBoundary(OriginalFeed);
